"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmailAddress = exports.getSplitEmailRegex = exports.getEmailRegex = void 0;
function getEmailRegex() {
    // W3C HTML5 spec: http://www.w3.org/TR/html5/forms.html#valid-e-mail-address
    // Regex spec: https://emailregex.com/
    // eslint-disable-next-line max-len, no-useless-escape, no-control-regex
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|("+"))@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/;
}
exports.getEmailRegex = getEmailRegex;
function getSplitEmailRegex() {
    // SmartSuite documentation:
    // https://gearheart.atlassian.net/wiki/spaces/SMAR/pages/1688371214/Text+Type+Fields#Edit-Record.3
    return /[\s,;]+/;
}
exports.getSplitEmailRegex = getSplitEmailRegex;
function validateEmailAddress(value) {
    // Check to detect correct email pattern
    return getEmailRegex().test(value);
}
exports.validateEmailAddress = validateEmailAddress;
